import { FavoriteTenders } from './FavoriteTenders';
import { CabinetLayout } from '@web-kc/shared/components';
import { useApp } from '@web-kc/core/providers';
import { useTranslation } from 'next-i18next';

export function FavoriteTendersCabinetPage() {
  const isKC = useApp() === 'kc';
  const { t } = useTranslation();

  return (
    <CabinetLayout
      pageTitle={t(
        `common:pageTitle.cabinet.favorite-tenders.${isKC ? 'kc' : 'rti'}`,
      )}
    >
      <FavoriteTenders type="tenders" />
    </CabinetLayout>
  );
}
